import { render, staticRenderFns } from "./MonCompte.vue?vue&type=template&id=4450f246&scoped=true"
import script from "./MonCompte.vue?vue&type=script&lang=js"
export * from "./MonCompte.vue?vue&type=script&lang=js"
import style0 from "./MonCompte.vue?vue&type=style&index=0&id=4450f246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450f246",
  null
  
)

export default component.exports